export default "__VITE_ASSET__V_Q21G$A__"